/**
 * Default Meta Tags
 */
export const PAGE_TITLE_META = `Ferguson Home - Your Vision. Our Expertise.
	- Faucets, Fixtures, Lighting, Appliances, Door Hardware & More`.replace(/[\t\n]+/g, ' ');

export const LOGIN_PAGE_TITLE_META = 'Ferguson Home Account Login – Use Your Build.com Login';
export const CREATE_ACCOUNT_PAGE_TITLE_META = 'Create Ferguson Home Account – Register Build.com Account';

export const PAGE_DESCRIPTION_META = `Huge Savings on over 500,000 Home Improvement products,
	Knowledgeable Customer Service 7 Days a Week, and FREE shipping offers on Faucets,
	Lighting, Door Hardware, Venting, Appliances, and much more.`.replace(/[\t\n]+/g, ' ');

export const LOGN_PAGE_DESCRIPTION_META =
	'Sign in to your Ferguson Home account. Build.com customers can use the same email and password to log in.';
export const CREATE_ACCOUNT_PAGE_DESCRIPTION_META =
	'Create a Ferguson Home account in minutes. New to Ferguson Home? Register using your Build.com account email and password';

/**
 * Appliance Package Builder Meta Tags
 */

export const APPLIANCE_PACKAGE_BUILDER_PAGE_TITLE_META = 'Kitchen Appliance Packages: Create Your Own | Ferguson Home';

export const APPLIANCE_PACKAGE_BUILDER_PAGE_DESCRIPTION_META = `Build your own custom kitchen appliance package at Ferguson Home!
	Select sizes, brands, finishes & more to create the perfect appliance bundle for your space.`.replace(/[\t\n]+/g, ' ');

/**
 * Projects About Page Meta Tags
 */

export const PROJECTS_ABOUT_TITLE_META = 'Ferguson Home Project Management Tool';

export const PROJECTS_ABOUT_DESCRIPTION_META =
	'Use our free project management tool to plan updates to your kitchen, bathroom, laundry room, and more.';
